import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useIntl } from 'react-intl'
import messages from './messages'
import { useDropzone } from 'react-dropzone'
import NiceModal from '@ebay/nice-modal-react'
import ErrorDialog from './components/ErrorDialog'

const FileUpload = ({ taskId, onFileAdded, showFileAdjustmentGuide, refetch}) => {
  const { formatMessage } = useIntl()
  const [progressBars, setProgressBars] = useState([])

  const onDrop = useCallback((acceptedFiles) => {
    setProgressBars(acceptedFiles ? acceptedFiles : []);
    const totalAcceptedFiles = acceptedFiles.length || 0
    let totalUploadedFiles = 0
    acceptedFiles.map((file) => {
      const body = new FormData()
      body.append('file', file);

      const xhr = new XMLHttpRequest();
      xhr.upload.onprogress = event => {
        const percentage = parseInt((event.loaded / event.total) * 100);
        setProgressBars((prev) => {
          return prev.map((prevFile) => {
            if (prevFile.name == file.name) {
              prevFile.progress = percentage
              return prevFile
            }
            return prevFile
          })
        })
      };
      xhr.responseType = 'json';
      xhr.onload = function(e) {
        if (!this.response.success) {
          const errorsArr = Object.values(this.response.errors)
          NiceModal.show(ErrorDialog, { errorsArr })
          showFileAdjustmentGuide(true)
        } else {
            totalUploadedFiles++
            onFileAdded(this.response.data)
            toastr.success(formatMessage(messages.successUpload))
        }

        if (totalUploadedFiles == totalAcceptedFiles) {
          refetch();
        }
      };
      xhr.open('POST', `/ordertask/handleDirectUpload?taskId=${taskId}`, true);
      xhr.send(body);
    })
  }, [taskId])

  
  

  const { acceptedFiles, getRootProps, getInputProps, isDragActive, isDragAccept } = useDropzone({ onDrop, maxSize: 10737418240 })

  return (
    <div>
      <div className='m-4 text-center'>
          { progressBars.map((bar) => (
            <>
              <p className="mb-1 font-medium">{bar.name}</p>
              <p className="mb-1 text-xs">{bar.progress}%</p>
              <div className="w- bg-gray-200 rounded-full h-2.5">
                <div className="bg-primary h-2.5 rounded-full"  style={{
                    width: `${bar.progress}%`
                  }}>
                </div>
              </div>
            </>
          ))}
      </div>
      <main className="w-full flex justify-center items-center mb-10">
          <div className="border border-gray-400 border-dashed p-4 flex justify-center items-center cursor-pointer" {...getRootProps()}>
            <input {...getInputProps()} />
            <p>{formatMessage(messages.uploadFilesHere)}</p>
            <div className="w-full text-center px-2 py-4 text-gray-500">
              {
                isDragActive ?
                  <p>{formatMessage(messages.dragActive)}</p> :
                  <p>{formatMessage(messages.dragInActive)} <span className="text-primary font-medium">click here</span></p>
              }
            </div>
          </div>
      </main>
    </div>
  )
}

export default FileUpload
